var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('Spin',{attrs:{"size":"large","fix":""}}):_c('div',[(_vm.list.length === 0)?_c('div',[_vm._v("本期账单暂无已开收据")]):_c('div',_vm._l((_vm.list),function(item,index){return _c('img',{key:index,staticClass:"receipt-class",attrs:{"src":item.imgUrl}})}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }